// SECTION - AUTH
export const SET_TOKEN = 'SET_TOKEN'
export const SET_REFRESH_TOKEN = 'SET_REFRESH_TOKEN'
// SECTION - APP
export const SET_USER = 'SET_USER'
// SECTION - SETTING
export const SET_THEME = 'SET_THEME'
export const SET_SYSTEM_THEME = 'SET_SYSTEM_THEME'
export const SET_LANGUAGE = 'SET_LANGUAGE'
// SECTION - ELECTRON
export const SET_UPDATE_STATUS = 'SET_UPDATE_STATUS'
export const SET_UPDATE_AVAILABLE_VERSION = 'SET_UPDATE_AVAILABLE_VERSION'
export const SET_UPDATE_ERROR_MESSAGE = 'SET_UPDATE_ERROR_MESSAGE'
export const SET_UPDATE_DOWNLOAD_PROGRESS = 'SET_UPDATE_DOWNLOAD_PROGRESS'
export const SET_APP_VERSION = 'SET_APP_VERSION'